import { useEffect } from 'react';

const CardContenido = ({ infoCard, setShowContent, localDateTimeToUTC }) => {

    useEffect(() => {
        return () => {
            setShowContent(false);
        }
    }, [setShowContent])

    return (
        <>
            <div className={"select-card-content mb-4 mt-3"}>
                <div className="ps-2 pt-2 select-card-content-title">Usuario:</div>
                <div className="ps-2 select-card-content-description">
                    {infoCard.original.usuario ? infoCard.original.usuario : "-"}
                </div>
                <div className={"ps-0 py-0 pt-3 pt-sm-4 d-flex flex-column flex-sm-row"}>
                    <div className={"col-sm-3 pl-2"}>
                        <div className="select-card-content-title">Método:</div>
                        <div className="select-card-content-description">
                            {infoCard.original.usuario ? infoCard.original.usuario : "-"}
                        </div>
                    </div>
                    <div className={"col-sm-3 ml-0 ml-sm-4 pl-2 pt-3 pt-sm-0"}>
                        <div className="select-card-content-title">Estado:</div>
                        <div className="select-card-content-description">
                            {infoCard.original.estado ? infoCard.original.estado : "-"}
                        </div>
                    </div>
                    <div className={"col-sm-3 ml-0 ml-sm-4 pl-2 pt-3 pt-sm-0"}>
                        <div className="select-card-content-title">URL:</div>
                        <div className="select-card-content-description">
                            {infoCard.original.url ? infoCard.original.url : "-"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="select-card-footer d-flex justify-content-between">
                <div className={"ps-2 pt-2 select-card-content-description"}>
                    {infoCard.original.fechaCreacion ? localDateTimeToUTC(infoCard.original.fechaCreacion) : "-"}
                </div>
            </div>
        </>
    )
}

export default CardContenido;